module.exports = __webpack_public_path__ + "static/carousel-00005-c08714b2efed8c434e626a1a948e7107.jpg";